module.exports = __webpack_public_path__ + "static/media/malocclusion_active.e79a5f22.svg";